module.exports = __webpack_public_path__ + "img/icon365.475a2618.png";